import { pathMaker } from "utils/helperFunctions";
import logo from "../../assets/images/logo/logo.png";
import { BiTrash } from "react-icons/bi";
export default function BrandItem({ data, deleteBrandFunc }) {
  return (
    <div className="col-6 col-sm-4 col-lg-3 col-xl-2 position-relative">
      <div
        className=" d-flex align-items-center m-2 p-2 border rounded shadow flex-grow-1"
        style={{ backgroundColor: "#f0f0f0" }}
      >
        <img
          src={
            data?.url != "" && data?.url != undefined && data?.url != null
              ? pathMaker(data?.url)
              : logo
          }
          className="border rounded me-2"
          style={{ width: 50, height: 50, objectFit: "contain" }}
        />
        <div className="font-14-600 ">{data?.name}</div>
      </div>
      <div
        className="position-absolute cursor-pointer"
        style={{ top: 0, left: 4 }}
        onClick={() => deleteBrandFunc(data)}
      >
        <BiTrash
          color="white"
          className="rounded-pill p-1"
          style={{ backgroundColor: "#aa2f2f", width: 20, height: 20 }}
        />
      </div>
    </div>
  );
}
